import React from "react";
import { Helmet } from "react-helmet-async";
import { BRAND } from "../lib/content";

export const Seo = ({ title, description, path = "/" }) => {
  const fullTitle = title ? `${title} | ${BRAND.name}` : `${BRAND.name} — ${BRAND.descriptor}`;
  const desc = description || BRAND.description;
  const url = `${BRAND.canonical}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
};
